import { useEffect, useState } from 'react';
import { AccessibilityInfo } from 'react-native';

/**
 * Vrai quand l'utilisateur a demandé au système de réduire les animations.
 *
 * Commence à VRAI : tant que le système n'a pas répondu, mieux vaut un écran fixe une fraction de
 * seconde qu'une animation qui démarre chez quelqu'un qui l'a désactivée. La réponse arrive en un
 * tour de boucle ; le réglage est ensuite suivi en direct.
 */
export function useReduceMotion(): boolean {
  const [reduit, setReduit] = useState(true);

  useEffect(() => {
    let actif = true;
    AccessibilityInfo.isReduceMotionEnabled()
      .then((valeur) => {
        if (actif) setReduit(valeur);
      })
      .catch(() => {
        // Réponse impossible : on reste sur « réduit », le choix prudent.
      });
    const abonnement = AccessibilityInfo.addEventListener('reduceMotionChanged', setReduit);
    return () => {
      actif = false;
      abonnement.remove();
    };
  }, []);

  return reduit;
}
